import gql from 'graphql-tag'
export const SEARCH_USER = gql`query searchUsers($username: String, $numberToShow: Int, $cursor: String, $role: String, $roles: [String], $email: String ){
  users(userProfile_username: $username, first: $numberToShow, after: $cursor, roles_id: $role, roles_id_list: $roles, email: $email) {
    edges {
      node {
          id
        email
        userProfile {
          id
          username
          firstName
          lastName
          image {
            id
            contentUrl
          }
        }
      }
    }
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage  
    }
  }
}`

export const USER_EXISTS = gql`query UserExists($username: String!) {
  existsUser(username: $username) {
    userProfile {
      username
    }
  }
}`